const getResourses = async (url) => {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Couldn't reach ${url}, status ${res.sta}`);
  }

  return await res.json();
};

const postData = async (url, data) => {
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: data,
  });

  return await res.json();
};

export {getResourses, postData}